import { Map } from "maplibre-gl";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAccount } from "./state";

export type MapContext = [Map | undefined, (map: Map) => void];
export const CaMapContext = createContext<MapContext>([undefined, () => {}]);
export const CaMapProvider = CaMapContext.Provider;

export const useCaMap = () => useContext(CaMapContext)[0];
export const useCaMapProvider = () => {
  return useState<Map | undefined>(undefined);
};

type eventType = "zoom" | "zoomend" | "move" | "moveend";
function getEventData(type: eventType, map?: Map) {
  if (!map) return null;
  switch (type) {
    case "zoom":
    case "zoomend":
      return map.getZoom();
    case "move":
    case "moveend":
      return map.getBounds();
    default:
      return null;
  }
}

export const useCaMapEvents = (...events: eventType[]) => {
  const map = useCaMap();
  const [eventData, setEventData] = useState<any[]>(() => events.map((e) => getEventData(e, map)));
  const callBack = useCallback(
    () => {
      const newData = events.map((e) => getEventData(e, map));
      setEventData(newData);
    },
    // eslint-disable-next-line
    [map, ...events]
  );
  useEffect(() => {
    if (!map) return;
    events.forEach((eventName) => map.on(eventName, callBack));
    // direct syncen: de initiële state is berekend vóór de map bestond en
    // zou anders pas na het eerste event kloppen
    callBack();
    return () => events.forEach((eventName) => map.off(eventName, callBack));
    // eslint-disable-next-line
  }, [map, callBack, ...events]);
  return eventData;
};

export const CheckUser = () => {
  const user = useAccount();
  const navigate = useNavigate();
  useEffect(() => {
    console.log("CheckUser");
    user.refresh();
    navigate("/");
  }, [navigate, user]);
  // TODO refresh user, reroute to /
  return null;
};
